import { type ClassValue, clsx } from 'clsx';
import {
	// type AnyClassGroupIds, // Not exported :(
	// type AnyThemeGroupIds, // Not exported :(
	// type ClassDefinition, // Not exported :(
	// type ClassGroup, // Not exported :(
	// type ClassObject, // Not exported :(
	type ClassValidator,
	// type ClassNameValue,
	// type ConfigExtension,
	// type ConfigGroupsPart, // Not exported :(
	type DefaultClassGroupIds,
	type DefaultThemeGroupIds,
	// type PartialPartial, // Not exported :(
	// type ThemeGetter, // Not exported :(
	// type ThemeObject, // Not exported :(
	getDefaultConfig,
	extendTailwindMerge,
	// fromTheme,
	twJoin,
} from 'tailwind-merge';

// import { cn } from '@hdir/tailwindcss';
import { includes } from '@enonic/js-utils/array/includes';
import { HDIR_THEME_6_1_66 } from '../../app/overdosefare/tailwind/hdir';
import { OVERDOSEFARE_THEME_6_1_66 } from '../../app/overdosefare/tailwind/overdosefare';
import { DESIGN } from '../../app/overdosefare/tailwind/tokens';
import { getLeafStrings } from '../../app/overdosefare/tailwind/getLeafStrings';
import { getStringPaths } from '../../app/overdosefare/tailwind/getStringPaths';

const DEBUG = false;

type PartialPartial<T> = {
	[P in keyof T]?: Partial<T[P]>;
};

type AnyClassGroupIds = string;
type AnyThemeGroupIds = string;

interface ThemeGetter {
	(theme: ThemeObject<AnyThemeGroupIds>): ClassGroup<AnyClassGroupIds>;
	isThemeGetter: true;
}

type ClassObject<ThemeGroupIds extends string> = Record<string, readonly ClassDefinition<ThemeGroupIds>[]>;

type ClassDefinition<ThemeGroupIds extends string> = string | ClassValidator | ThemeGetter | ClassObject<ThemeGroupIds>;

type ClassGroup<ThemeGroupIds extends string> = readonly ClassDefinition<ThemeGroupIds>[];

type ThemeObject<ThemeGroupIds extends string> = Record<ThemeGroupIds, ClassGroup<ThemeGroupIds>>;

interface ConfigGroupsPart<ClassGroupIds extends string, ThemeGroupIds extends string> {
	/**
	 * Theme scales used in classGroups.
	 * The keys are the same as in the Tailwind config but the values are sometimes defined more broadly.
	 */
	theme: NoInfer<ThemeObject<ThemeGroupIds>>;
	/**
	 * Object with groups of classes.
	 * @example
	 * {
	 *     // Creates group of classes `group`, `of` and `classes`
	 *     'group-id': ['group', 'of', 'classes'],
	 *     // Creates group of classes `look-at-me-other` and `look-at-me-group`.
	 *     'other-group': [{ 'look-at-me': ['other', 'group']}]
	 * }
	 */
	classGroups: NoInfer<Record<ClassGroupIds, ClassGroup<ThemeGroupIds>>>;
	/**
	 * Conflicting classes across groups.
	 * The key is ID of class group which creates conflict, values are IDs of class groups which receive a conflict.
	 * A class group ID is the key of a class group in classGroups object.
	 * @example { gap: ['gap-x', 'gap-y'] }
	 */
	conflictingClassGroups: NoInfer<Partial<Record<ClassGroupIds, readonly ClassGroupIds[]>>>;
	/**
	 * Postfix modifiers conflicting with other class groups.
	 * A class group ID is the key of a class group in classGroups object.
	 * @example { 'font-size': ['leading'] }
	 */
	conflictingClassGroupModifiers: NoInfer<Partial<Record<ClassGroupIds, readonly ClassGroupIds[]>>>;
}

/* eslint-disable */
function arrayDiff(a: string[], b: string[]): { onlyInA: string[], onlyInB: string[] } {
	let i = 0, j = 0;
	const onlyInA: string[] = [];
	const onlyInB: string[] = [];

	while (i < a.length || j < b.length) {
		if (i === a.length) { onlyInB.push(b[j++]); continue; }
		if (j === b.length) { onlyInA.push(a[i++]); continue; }

		if (a[i] < b[j]) onlyInA.push(a[i++]);
		else if (a[i] > b[j]) onlyInB.push(b[j++]);
		else { i++; j++; } // equal, skip both
	}

	return { onlyInA, onlyInB };
}
/* eslint-enable */

// function toClassValue() {
// 	if ()'var(--'
// }

// const BORDER_COLOR = [
// 	'DEFAULT',
// 	{
// 		action: [
// 			'DEFAULT',
// 			'disabled',
// 			'hover',
// 			'active',
// 			'focus',
// 			'subtle',
// 			{
// 				primary: ['DEFAULT', 'hover', 'active', 'disabled'],
// 				secondary: ['DEFAULT', 'hover', 'active', 'disabled'],
// 				tertiary: ['DEFAULT', 'hover', 'active', 'disabled'],
// 				chip:['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', 'error'],
// 			},
// 		],
// 		feedback: [
// 			'success',
// 			'warning',
// 			'info',
// 			'error',
// 		],
// 		neutral: ['DEFAULT', 'inverted', 'subtle'],

// 	},
// ];

// const SPACING = ['0', 'xxs', 'xs', 'sm', 'md', 'lg', 'xl', 'xxl', 'xxxl', 'auto'];

type AdditionalClassGroupIds =
	| 'line-height'
	| 'textStroke'
	| 'textStrokeColor'
;

type AdditionalThemeGroupIds =
	| 'accentColor'
	| 'backgroundColor'
	| 'boxShadow'
	| 'boxShadowColor'
	| 'caretColor'
	| 'divideColor'
	| 'fill'
	| 'fontSize'
	| 'fontWeight'
	| 'maxWidth'
	| 'outlineColor'
	| 'placeholderColor'
	| 'ringColor'
	| 'ringOffsetColor'
	| 'screens'
	| 'scrollMargin'
	| 'scrollPadding'
	| 'stroke'
	| 'textColor'
	| 'textDecorationColor'
	| 'textStroke'
	| 'textStrokeColor'
	| 'width'
;

const gap = getStringPaths(HDIR_THEME_6_1_66.gap, 'gap');
// const padding = ([] as string[]).concat(
// 	getStringPaths(HDIR_THEME_6_1_66.padding, 'p'),
// 	getStringPaths(HDIR_THEME_6_1_66.padding, 'pb'),
// 	getStringPaths(HDIR_THEME_6_1_66.padding, 'pl'),
// 	getStringPaths(HDIR_THEME_6_1_66.padding, 'pr'),
// 	getStringPaths(HDIR_THEME_6_1_66.padding, 'pt'),
// 	getStringPaths(HDIR_THEME_6_1_66.padding, 'px'),
// 	getStringPaths(HDIR_THEME_6_1_66.padding, 'py'),
// );
const space = getStringPaths(HDIR_THEME_6_1_66.space, 'space');

// ↓ Optional config overrides
//   Only elements from the second level onwards are overridden
const override: PartialPartial<ConfigGroupsPart<AdditionalClassGroupIds | DefaultClassGroupIds, AdditionalThemeGroupIds | DefaultThemeGroupIds>> = {
	// ↓ Theme scales to override
	theme: {
		// Add your override keys here (values can be dummy strings)
		// tailwind-merge only cares about the **keys**, not the actual values
		accentColor: getStringPaths(HDIR_THEME_6_1_66.accentColor, 'accent'),
		backgroundColor: getStringPaths(HDIR_THEME_6_1_66.backgroundColor, 'bg'),
		borderColor: getStringPaths(HDIR_THEME_6_1_66.borderColor, 'border'),
		borderRadius: getStringPaths(HDIR_THEME_6_1_66.borderRadius, 'rounded'),
		borderWidth: getStringPaths(HDIR_THEME_6_1_66.borderWidth , 'border'),
		boxShadow: getStringPaths(OVERDOSEFARE_THEME_6_1_66.boxShadow, 'shadow'),
		boxShadowColor: getStringPaths(HDIR_THEME_6_1_66.boxShadowColor, 'shadow'),
		caretColor: getStringPaths(HDIR_THEME_6_1_66.caretColor, 'caret'),
		divideColor: getStringPaths(HDIR_THEME_6_1_66.divideColor, 'divide'),
		fill: getStringPaths(HDIR_THEME_6_1_66.fill, 'fill'),
		fontSize: getStringPaths(HDIR_THEME_6_1_66.fontSize, 'text'),
		fontWeight: getStringPaths(HDIR_THEME_6_1_66.fontWeight, 'font'),

		// gap, // Seems this is not needed when added to extend.classGroups below.

		gradientColorStops: getStringPaths(HDIR_THEME_6_1_66.gradientColorStops, 'from'),

		// Seems this is not needed when m, mb, ... are added to extend.classGroups below.
		// margin: ([] as string[]).concat(
		// 	getStringPaths(HDIR_THEME_6_1_66.margin, 'm'),
		// 	getStringPaths(HDIR_THEME_6_1_66.margin, 'mb'),
		// 	getStringPaths(HDIR_THEME_6_1_66.margin, 'ml'),
		// 	getStringPaths(HDIR_THEME_6_1_66.margin, 'mr'),
		// 	getStringPaths(HDIR_THEME_6_1_66.margin, 'mt'),
		// 	getStringPaths(HDIR_THEME_6_1_66.margin, 'mx'),
		// 	getStringPaths(HDIR_THEME_6_1_66.margin, 'my'),
		// ),

		outlineColor: getStringPaths(HDIR_THEME_6_1_66.outlineColor, 'outline'),

		// padding, // Seems this is not needed when p, pb, ... are added to extend.classGroups below.

		placeholderColor: getStringPaths(HDIR_THEME_6_1_66.placeholderColor).map(v => `placeholder:${v}`),
		ringColor: getStringPaths(HDIR_THEME_6_1_66.ringColor, 'ring'),
		ringOffsetColor: getStringPaths(HDIR_THEME_6_1_66.ringOffsetColor, 'ring-offset'),
		scrollMargin: ([] as string[]).concat(
			getStringPaths(HDIR_THEME_6_1_66.scrollMargin, 'scoll-m'),
			getStringPaths(HDIR_THEME_6_1_66.scrollMargin, 'scoll-mb'),
			getStringPaths(HDIR_THEME_6_1_66.scrollMargin, 'scoll-ml'),
			getStringPaths(HDIR_THEME_6_1_66.scrollMargin, 'scoll-mr'),
			getStringPaths(HDIR_THEME_6_1_66.scrollMargin, 'scoll-mt'),
			getStringPaths(HDIR_THEME_6_1_66.scrollMargin, 'scoll-mx'),
			getStringPaths(HDIR_THEME_6_1_66.scrollMargin, 'scoll-my'),
		),
		scrollPadding: ([] as string[]).concat(
			getStringPaths(HDIR_THEME_6_1_66.scrollPadding, 'scoll-p'),
			getStringPaths(HDIR_THEME_6_1_66.scrollPadding, 'scoll-pb'),
			getStringPaths(HDIR_THEME_6_1_66.scrollPadding, 'scoll-pl'),
			getStringPaths(HDIR_THEME_6_1_66.scrollPadding, 'scoll-pr'),
			getStringPaths(HDIR_THEME_6_1_66.scrollPadding, 'scoll-pt'),
			getStringPaths(HDIR_THEME_6_1_66.scrollPadding, 'scoll-px'),
			getStringPaths(HDIR_THEME_6_1_66.scrollPadding, 'scoll-py'),
		),
		space, // This doesn't seem to be enough to make twMerge understand our custom gap-*
		// spacing: space, // This did not help neither.
		stroke: getStringPaths(HDIR_THEME_6_1_66.stroke, 'stroke'),
		textColor: getStringPaths(HDIR_THEME_6_1_66.textColor, 'text'),
		textDecorationColor: getStringPaths(HDIR_THEME_6_1_66.textDecorationColor, 'decoration'),
	},
	// ↓ Class groups to override
	classGroups: {
		// WARNING: This means twMerge will ONLY understand the onces listed here, so for example
		// it will not understand that gap-96 is a gap value, since it's not in the list.
		// gap,
		'ring-color': [{
			ring: getLeafStrings(HDIR_THEME_6_1_66.ringColor)
				.map((token) => `[${token}]`),
		}],
		'ring-w': [{
			ring: [
				`[${DESIGN.border.sm}]`,
				`[${DESIGN.border.md}]`,
				`[${DESIGN.border.lg}]`,
			],
		}],
	},
	conflictingClassGroups: {
		// ↓ ID of class group which creates a conflict with…
		//           ↓ …classes from groups with these IDs
		//   Here we remove the default conflict between the font-size and leading class
		//   groups.
		'font-size': [],
	},
	// conflictingClassGroupModifiers: {
	// 	// You probably won't need this, but it follows the same shape as
	// 	// `conflictingClassGroups`.
	// },
	// ↓ Modifiers whose order among multiple modifiers should be preserved because their
	//   order changes which element gets targeted. Overrides default value.
	// orderSensitiveModifiers: [],
};

const extend: PartialPartial<ConfigGroupsPart<AdditionalClassGroupIds | DefaultClassGroupIds, AdditionalThemeGroupIds | DefaultThemeGroupIds>> = {
	theme: {
		// Add your extention keys here (values can be dummy strings)
		// tailwind-merge only cares about the **keys**, not the actual values
		boxShadow: getStringPaths(HDIR_THEME_6_1_66.extend.boxShadow, 'shadow'),
		// gap, // Only our extensions over the tailwind default onces should be listed here.
		margin: ([] as string[]).concat(
			getStringPaths(OVERDOSEFARE_THEME_6_1_66.extend.margin, 'm'),
			getStringPaths(OVERDOSEFARE_THEME_6_1_66.extend.margin, 'mb'),
			getStringPaths(OVERDOSEFARE_THEME_6_1_66.extend.margin, 'ml'),
			getStringPaths(OVERDOSEFARE_THEME_6_1_66.extend.margin, 'mr'),
			getStringPaths(OVERDOSEFARE_THEME_6_1_66.extend.margin, 'mt'),
			getStringPaths(OVERDOSEFARE_THEME_6_1_66.extend.margin, 'mx'),
			getStringPaths(OVERDOSEFARE_THEME_6_1_66.extend.margin, 'my'),
		),
		maxWidth: ([] as string[]).concat(
			getStringPaths(HDIR_THEME_6_1_66.extend.maxWidth, 'max-w'),
			getStringPaths(OVERDOSEFARE_THEME_6_1_66.extend.maxWidth, 'max-w'),
		),
		screens: getStringPaths(OVERDOSEFARE_THEME_6_1_66.extend.screens),
		textColor: getStringPaths(OVERDOSEFARE_THEME_6_1_66.extend.textColor, 'text'),
		textStroke: [
			'text-stroke-thin', // TODO Hardcode
		],
		textStrokeColor: [
			'text-stroke-color-[#A6A6A6]', // TODO HARDCODE
			'text-stroke-color-[#002949]', // TODO HARDCODE
		],
		width: getStringPaths(HDIR_THEME_6_1_66.extend.width, 'w'),
	},
	classGroups: {
		// NOTE: Adding extensions to gap here allows twMerge to understand both it's default
		// patterns (and values?) like gap-96 and our extensions like gap-lg.
		// However whether the css file contains a class for gap-96 depends on the
		// "tailwind configuration", NOT the "tailwind merge configuration".
		// The goal should be for both configs to align... or at least work together.
		gap,

		m: getStringPaths(HDIR_THEME_6_1_66.margin, 'm')
			.concat(getStringPaths(OVERDOSEFARE_THEME_6_1_66.extend.margin, 'm')),
		mb: getStringPaths(HDIR_THEME_6_1_66.margin, 'mb')
			.concat(getStringPaths(OVERDOSEFARE_THEME_6_1_66.extend.margin, 'mb')),
		ml: getStringPaths(HDIR_THEME_6_1_66.margin, 'ml')
			.concat(getStringPaths(OVERDOSEFARE_THEME_6_1_66.extend.margin, 'ml')),
		mr: getStringPaths(HDIR_THEME_6_1_66.margin, 'mr')
			.concat(getStringPaths(OVERDOSEFARE_THEME_6_1_66.extend.margin, 'mr')),
		mt: getStringPaths(HDIR_THEME_6_1_66.margin, 'mt')
			.concat(getStringPaths(OVERDOSEFARE_THEME_6_1_66.extend.margin, 'mt')),
		mx: getStringPaths(HDIR_THEME_6_1_66.margin, 'mx')
			.concat(getStringPaths(OVERDOSEFARE_THEME_6_1_66.extend.margin, 'mx')),
		my: getStringPaths(HDIR_THEME_6_1_66.margin, 'my')
			.concat(getStringPaths(OVERDOSEFARE_THEME_6_1_66.extend.margin, 'my')),

		p: getStringPaths(HDIR_THEME_6_1_66.padding, 'p'),
		pb: getStringPaths(HDIR_THEME_6_1_66.padding, 'pb'),
		pl: getStringPaths(HDIR_THEME_6_1_66.padding, 'pl'),
		pr: getStringPaths(HDIR_THEME_6_1_66.padding, 'pr'),
		pt: getStringPaths(HDIR_THEME_6_1_66.padding, 'pt'),
		px: getStringPaths(HDIR_THEME_6_1_66.padding, 'px'),
		py: getStringPaths(HDIR_THEME_6_1_66.padding, 'py'),

		textStroke: [{
			'text-stroke': [
				'thin', // TODO HARDCODE
				// '{size}', // Won't work without mergeConfigs and validator?
			],
		}],
		// 'textStroke': [
		// 	[
		// 		// 'text-stroke',
		// 		// 'text-stroke-{size}',
		// 		'text-stroke-thin',
		// 	],
		// ],
		'textStrokeColor': [{
			'text-stroke': [
				// '{color}', // Won't work without mergeConfigs and validator?
				'[#A6A6A6]', // TODO HARDCODE
				'[#002949]', // TODO HARDCODE
			],
		}],
		// 'textStrokeColor': [
		// 	[
		// 		// 'text-stroke-color',
		// 		// 'text-stroke-color-{color}',
		// 		'text-stroke-[#A6A6A6]',
		// 		'text-stroke-[#002949]',
		// 	],
		// ],
		// 'textStrokeFill': [
		// 	[
		// 		// 'text-stroke-fill',
		// 		'text-stroke-fill-{color}',
		// 	],
		// ],
	},
	// conflictingClassGroupModifiers: {
	// },
	// conflictingClassGroups: {
	// }
};

const createCn =
	(prefix?: string) => {
		// console.log('override', override);
		// console.log('extend', extend);
		const twMerge = extendTailwindMerge<AdditionalClassGroupIds, AdditionalThemeGroupIds>({
			prefix,
			override,
			extend,
		});
		// TODO always calling clsx, when it's rarely needed, is an overhead, however small.
		// So we should change signature to accept ClassNameValue[] rather than ClassValue[]
		// and let users manually call clsx before using merge.
		return (...inputs: ClassValue[]) => twMerge(clsx(inputs));
	};

const cnProd = createCn();

export const cnDebug = (...classValues: ClassValue[]): string => {
	const after = cnProd(classValues);

	// TODO always calling clsx, when it's rarely needed, is an overhead, however small.
	// So we should change signature to accept ClassNameValue[] rather than ClassValue[]
	// and let users manually call clsx before using merge.
	// NOTE: twJoin only joins the class strings together and doesn't deal with conflicting classes.
	const before = twJoin(clsx(classValues));

	// This can be used to debug a specific problem (when twMerge fails to remove something):
	// if (
	// 	before === 'flex flex-col gap-xs bg-surface-neutral-default gap-lg tablet:gap-xl'
	// ) {
	// 	console.debug('────────────────────────────────────────────────────────────────────────────────');
	// 	console.debug('classValues', classValues);
	// 	// console.debug('override.theme?.gap', override.theme?.gap);
	// 	// console.debug('extend.theme?.gap', extend.theme?.gap);
	// 	// const defaultConfig = getDefaultConfig();
	// 	// console.debug('defaultConfig', defaultConfig);
	// 	// console.debug('classValues', classValues);
	// 	console.debug('before', before);
	// 	console.debug('after', after); // Can be used to find element in Html
	// }

	// WARNING: This means it will ONLY debug when twMerge removed something (from after),
	// and not when twMerge fails to to it's job!
	if (after.length === before.length) {
		return after;
	}

	const beforeArray = before.split(' ');
	const afterArray = after.split(' ');

	/* eslint-disable */
	const diff = arrayDiff(beforeArray.sort(), afterArray.sort());
	/* eslint-enable */
	const { onlyInA } = diff;

	// Don't debug known good removals :)
	if (
		includes(onlyInA, 'flex')
		&& (
			includes(beforeArray, 'contents')
			|| includes(beforeArray, 'hidden')
		)
	) {
		onlyInA.splice(onlyInA.indexOf('flex'), 1);
	}

	if (includes(onlyInA, 'font-semibold') && includes(beforeArray, 'font-normal')) {
		onlyInA.splice(onlyInA.indexOf('font-semibold'), 1);
	}

	if (includes(onlyInA, 'gap-xs') && includes(beforeArray, 'gap-lg')) {
		onlyInA.splice(onlyInA.indexOf('gap-xs'), 1);
	}

	if (includes(onlyInA, 'text-xl') && includes(beforeArray, 'text-lg')) {
		onlyInA.splice(onlyInA.indexOf('text-xl'), 1);
	}

	if (onlyInA.length) {
		console.debug('────────────────────────────────────────────────────────────────────────────────');
		const defaultConfig = getDefaultConfig();
		console.debug('defaultConfig', defaultConfig);
		// console.debug('classValues', classValues);
		console.debug('before', before);
		// console.debug('beforeArray', beforeArray);
		console.debug('after', after); // Can be used to find element in Html
		// console.debug('afterArray', afterArray);
		console.log('removed', onlyInA);
	}

	return after;
};

// When there are conflicts the last one should win.
// It doesn't matter if classValues is a single string or an array.
export const customTwMerge = (...classValues: ClassValue[]): string => DEBUG
	? cnDebug(classValues)
	: cnProd(classValues);
